<!-- <button
  class="items-center justify-center rounded-md w-[24px] h-[24px] border border-gray-500 flex transition-all"
  [ngStyle]="{
    backgroundColor: isCheck ? '#0058e9' : 'white'
  }"
  (click)="isCheck = !isCheck"
> -->
  <input
    class="bg-transparent border-none"
    type="checkbox"
   
  />
  <!-- <img *ngIf="isCheck == true" src="../../../assets/image/icon.png" alt="" />
</button> -->
